import { Inject, Injectable } from '@angular/core';

import { InterviewOperation, InterviewStrategy, SendInterviewMessageRequest } from '@empathy/ai-chat';

import { AdminInterviewContext } from './admin-interview-context';
import { EnvironmentConfig } from '../config/environment.config';

@Injectable()
export class AdminInterviewStrategy implements InterviewStrategy<AdminInterviewContext> {
  constructor(@Inject('environment') private environment: EnvironmentConfig) {}

  resolve(operation: InterviewOperation, ctx: AdminInterviewContext): { url: string; body: unknown } {
    const url = `${this.environment.endPoint}project/${ctx.projectId}/research/${ctx.methodId}/ai-interview/${operation}`;

    switch (operation) {
      case 'start':
        return { url, body: {} };
      case 'send':
        return { url, body: null };
      default:
        return { url, body: { token: ctx.token } };
    }
  }

  applyToken(ctx: AdminInterviewContext, token: string): AdminInterviewContext {
    return { ...ctx, token };
  }

  enrichPayload(ctx: AdminInterviewContext, payload: SendInterviewMessageRequest): SendInterviewMessageRequest {
    return { ...payload, token: ctx.token };
  }
}
